import { render, staticRenderFns } from "./MainPopups.vue?vue&type=template&id=208bf946&scoped=true"
import script from "./MainPopups.vue?vue&type=script&lang=js"
export * from "./MainPopups.vue?vue&type=script&lang=js"
import style0 from "./MainPopups.vue?vue&type=style&index=0&id=208bf946&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208bf946",
  null
  
)

export default component.exports